<template>
    <div>
        <footer class="page-footer font-small bg-info pt-3 pb-3">
            <div class="footer-copyright text-center text-white">2020 - Orcebot</div>
            <div class="footer-copyright text-center text-white">Colaborador: Ronaldo Nolasco</div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style>

</style>